module.exports = __webpack_public_path__ + "img/1560716741.7dc6649b.jpg";